import { render, staticRenderFns } from "./WeekHourHot.vue?vue&type=template&id=86bca1b2&scoped=true&"
import script from "./WeekHourHot.vue?vue&type=script&lang=js&"
export * from "./WeekHourHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bca1b2",
  null
  
)

export default component.exports